export const siteConfig = {
  organizationName: 'Family Value Foundation',
  shortDescription:
    'Helping families with limited incomes address essential repairs and protect the homes they depend on.',
  email: '[Contact email]',
} as const;
